import script from "./StructureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StructureView.vue?vue&type=script&setup=true&lang=ts"

import "./StructureView.vue?vue&type=style&index=0&id=510ae46d&lang=css"

const __exports__ = script;

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter,QBtn,QTooltip,QTabs,QTab,QTabPanels,QTabPanel});
